/**
 * Detects if we are in the IOS app
 *
 * @returns  {number}  The random seed
 * @public
 */
module.exports = navigator.userAgent.indexOf("vikaru-app-ios") !== -1;
